import BasicLayout from "../../layout/curr.vue"
// const pre = ' - 极客轻商城系统';
const meta = {
  auth: true
};

export default {
  path: 'geekPay',
  name: 'geekPay',
  component: BasicLayout,
  children: [{
      path: 'qrcode',
      name: 'qrcode',
      component: () => import("@/pages/admin/geekPay/qrcode.vue"),
      meta: {
        ...meta,
        title: '收款码管理 - 极客商城系统'
      }
    },
   
    {
      path: "*",
      redirect: '/home'
    },

  ]
};